import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ProjectWizard from "@/pages/ProjectWizard";
import ProjectAnalysis from "@/pages/ProjectAnalysis";
import DesignDirections from "@/pages/DesignDirections";
import DesignDNA from "@/pages/DesignDNA";
import RoomMoodboards from "@/pages/RoomMoodboards";
import PresentationViewer from "@/pages/PresentationViewer";
import BrandSettings from "@/pages/BrandSettings";
import ProjectsIndex from "@/pages/ProjectsIndex";
import { AuthProvider } from "@/context/AuthContext";
import { AuthCallback, ProtectedRoute } from "@/components/AuthGate";
import "@/App.css";

const P = (el) => <ProtectedRoute>{el}</ProtectedRoute>;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={P(<Dashboard />)} />
      <Route path="/projects" element={P(<ProjectsIndex />)} />
      <Route path="/project/new" element={P(<ProjectWizard />)} />
      <Route path="/project/:id/edit" element={P(<ProjectWizard />)} />
      <Route path="/project/:id/analysis" element={P(<ProjectAnalysis />)} />
      <Route path="/project/:id/directions" element={P(<DesignDirections />)} />
      <Route path="/project/:id/dna" element={P(<DesignDNA />)} />
      <Route path="/project/:id/moodboards" element={P(<RoomMoodboards />)} />
      <Route path="/project/:id/presentation" element={P(<PresentationViewer />)} />
      <Route path="/brand-settings" element={P(<BrandSettings />)} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" theme="light" />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
